<template>
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 16 16"
        style="enable-background:new 0 0 16 16;" xml:space="preserve" aria-hidden="true">
        <g id="Hurricane_00000051341580735198874040000017942998388542642838_">
            <g>
                <path id="Hurricane" class="st3" d="M8.4,2.5c-1.8,0-3.5,0.8-4.7,2.2h0C4,3.2,5,1.8,6.3,0.9c0.2-0.1,0.2-0.4,0.2-0.6
			C6.3,0.1,6.1,0,5.9,0.1C3.2,1,1.4,3.6,1.4,6.6c0,3.8,2.9,6.8,6.4,6.8c1.8,0,3.5-0.8,4.8-2.2c-0.4,1.6-1.4,3-2.7,3.9
			c-0.2,0.1-0.2,0.4-0.2,0.6c0.1,0.2,0.3,0.3,0.5,0.2c2.7-0.9,4.6-3.5,4.6-6.5C14.8,5.6,11.9,2.5,8.4,2.5z M8.1,9.8
			C7.1,9.8,6.4,9,6.4,8c0-1,0.8-1.8,1.7-1.8C9,6.1,9.8,7,9.8,8C9.8,9,9,9.8,8.1,9.8z" />
                <path class="st3" d="M6.5,14.7C6.5,14.7,6.5,14.7,6.5,14.7C2.7,14.1,0,10.7,0,6.6c0-0.1,0.1-0.2,0.2-0.2s0.2,0.1,0.2,0.2
			c0,3.8,2.6,7.1,6.2,7.7c0.1,0,0.2,0.1,0.2,0.2C6.7,14.6,6.6,14.7,6.5,14.7z" />
                <path class="st3" d="M15.8,9.6c-0.1,0-0.2-0.1-0.2-0.2c0-3.8-2.6-7.1-6.2-7.7c-0.1,0-0.2-0.1-0.2-0.2c0-0.1,0.1-0.2,0.2-0.2
			c3.8,0.6,6.5,4,6.5,8.1C16,9.5,15.9,9.6,15.8,9.6z" />
            </g>
        </g>
    </svg>
</template>

<style scoped>
path {
    fill: white;
}
</style>
